export const organisationRoles = [
  {
    id: 'career-counselor',
    title: 'Career Counselor',
    summary: 'Guide students through aptitude insights, stream choices, college options, and long-term career planning.',
    eligibility: ['Master degree or certification in counseling, education, psychology, or career guidance', '2+ years of student-facing guidance experience', 'Strong documentation and parent communication skills'],
    responsibilities: ['Interpret MindVrik career and aptitude reports', 'Conduct student and parent consultations', 'Create stream, subject, and college guidance notes'],
    benefits: ['Verified MindVrik expert profile', 'Structured case pipeline', 'AI-assisted pre-session reports', 'Flexible consultation slots'],
  },
  {
    id: 'clinical-psychologist',
    title: 'Clinical Psychologist',
    summary: 'Support students and parents with ethical, non-diagnostic interpretation and referral-aware psychological guidance.',
    eligibility: ['Recognized clinical psychology qualification', 'Valid registration or supervised practice credentials where applicable', 'Experience with adolescents, parents, and school ecosystems'],
    responsibilities: ['Review psychological assessment indicators', 'Flag referral needs where appropriate', 'Guide parents with safe, evidence-informed next steps'],
    benefits: ['High-trust professional network', 'Clear advisory boundaries', 'Secure student records', 'Human + AI collaboration tools'],
  },
  {
    id: 'workshop-expert',
    title: 'Workshop Expert',
    summary: 'Deliver school and group workshops on career awareness, future skills, emotional wellbeing, and decision readiness.',
    eligibility: ['Workshop, training, counseling, or education background', 'Strong facilitation and presentation skills', 'Comfort with schools, parents, and teenage audiences'],
    responsibilities: ['Run career guidance and awareness workshops', 'Share practical future-skills frameworks', 'Coordinate post-workshop assessment pathways'],
    benefits: ['School partnership opportunities', 'Workshop playbooks', 'MindVrik brand-backed programs', 'Scalable group engagement'],
  },
];

export const experts = [
  {
    id: 'shashi-rani',
    name: 'Dr. Shashi Rani',
    image: '/assets/dr-shashi-rani.png',
    role: 'State Consultant - Himachal Pradesh',
    qualification: 'BDS Graduate, registered with Himachal Pradesh State Dental Council',
    experience: '10+ Years',
    languages: ['English', 'Hindi'],
    specializations: ['Healthcare Programs', 'Field Operations', 'Project Implementation'],
    availability: ['By appointment'],
    location: 'Himachal Pradesh, India',
    rating: 4.9,
    sessions: '10+ yrs',
    bio: 'Healthcare professional with over 10 years of experience in healthcare, project implementation, and program management. She brings strong field experience and has worked with organisations like WHO on health initiatives.',
  },
  {
    id: 'sujata',
    name: 'Ms. Sujata',
    image: '/assets/ms-sujata.png',
    role: 'Career Coach and Motivational Counselor',
    qualification: 'Postgraduate in Clinical Psychology, PG Diploma in Guidance & Counselling, one-month psychiatrist training from PGIMS Rohtak',
    experience: '10+ Years',
    languages: ['English', 'Hindi'],
    specializations: ['Career Coaching', 'Motivational Counseling', 'Psychological Issues Counseling'],
    availability: ['By appointment'],
    location: 'India',
    rating: 4.8,
    sessions: '10+ yrs',
    bio: 'Career coach and motivational counselor with more than 10 years of experience in psychology, career coaching, and psychological issues counseling across Kendriya Vidyalaya schools, Army Public School, and private schools.',
  },
  {
    id: 'amit-kumar',
    name: 'Mr. Amit Kumar',
    image: '/assets/amit-kumar.png',
    role: 'Director and Program Implementation Expert',
    qualification: 'MBA Hospital Management, Masters in Public Health (MPH), PG in Guidance & Counselling',
    experience: '16+ Years',
    languages: ['English', 'Hindi'],
    specializations: ['Program Implementation', 'Public Health', 'Large-Scale Projects'],
    availability: ['By appointment'],
    location: 'India',
    rating: 4.9,
    sessions: '16+ yrs',
    bio: 'Director and program implementation expert with more than 16 years of experience in healthcare and large-scale project implementation with leading funding organisations including WHO, World Bank, USAID, and TISS.',
  },
  {
    id: 'sunita-gusain',
    name: 'Ms. Sunita Gusain',
    image: '/assets/ms-sunita-gusain.png',
    role: 'Director and Program Management Expert',
    qualification: 'Master of Social Work, Postgraduate degree in Sociology',
    experience: '18+ Years',
    languages: ['English', 'Hindi'],
    specializations: ['Program Management', 'Community Mobilization', 'Monitoring & Evaluation'],
    availability: ['By appointment'],
    location: 'India',
    rating: 4.9,
    sessions: '18+ yrs',
    bio: 'Social development professional with 18+ years of experience in public health, research, rural development, and community-based programs. She has worked with national and international development organizations on projects supported by USAID and other leading agencies, contributing to maternal and child health, newborn care, HIV/AIDS interventions, research, rural livelihood programs, capacity building, stakeholder engagement, and evidence-based program implementation.',
  },
];

export const careerCategories = [
  {
    id: 'engineering',
    title: 'Engineering',
    careers: ['Computer Engineer', 'Civil Engineer', 'Mechanical Engineer', 'Electronics Engineer'],
    detail: 'Build systems, infrastructure, products, and technology solutions through applied science and design.',
  },
  { id: 'medical', title: 'Medical', careers: ['Doctor', 'Dentist', 'Physiotherapist', 'Public Health Specialist'], detail: 'Serve health and wellbeing through clinical, allied, and research-led pathways.' },
  { id: 'law', title: 'Law', careers: ['Corporate Lawyer', 'Litigator', 'Policy Analyst', 'Legal Researcher'], detail: 'Work with justice, regulation, contracts, advocacy, and public policy.' },
  { id: 'design', title: 'Design', careers: ['UX Designer', 'Product Designer', 'Fashion Designer', 'Communication Designer'], detail: 'Combine creativity, empathy, and problem-solving to shape products and experiences.' },
  { id: 'commerce', title: 'Commerce', careers: ['Chartered Accountant', 'Financial Analyst', 'Investment Advisor', 'Tax Consultant'], detail: 'Understand money, business systems, accounting, markets, and financial decisions.' },
  { id: 'management', title: 'Management', careers: ['Product Manager', 'Business Analyst', 'Operations Manager', 'HR Manager'], detail: 'Lead teams, strategy, execution, and business growth across sectors.' },
  { id: 'ai', title: 'AI', careers: ['AI Engineer', 'Data Scientist', 'ML Researcher', 'Prompt Systems Specialist'], detail: 'Create intelligent systems using data, algorithms, product thinking, and ethics.' },
  { id: 'robotics', title: 'Robotics', careers: ['Robotics Engineer', 'Automation Specialist', 'Mechatronics Engineer', 'Drone Systems Designer'], detail: 'Blend mechanics, electronics, software, and automation for intelligent machines.' },
  { id: 'civil-services', title: 'Civil Services', careers: ['IAS Officer', 'IPS Officer', 'IFS Officer', 'Public Administrator'], detail: 'Serve society through governance, policy execution, administration, and leadership.' },
  { id: 'entrepreneurship', title: 'Entrepreneurship', careers: ['Startup Founder', 'Social Entrepreneur', 'Creator-Founder', 'Family Business Leader'], detail: 'Build ventures by identifying problems, creating value, and leading resilient teams.' },
  { id: 'future-skills', title: 'Future Skills', careers: ['Sustainability Analyst', 'Cybersecurity Specialist', 'No-Code Builder', 'Digital Strategist'], detail: 'Prepare for emerging roles shaped by technology, climate, creativity, and global change.' },
];

export const journeySteps = [
  ['Class 7', 'Early Self Discovery'],
  ['Class 8', 'Strength Mapping'],
  ['Class 9', 'Career Awareness'],
  ['Class 10', 'Stream Selection'],
  ['Class 11', 'Career Planning'],
  ['Class 12', 'College Applications'],
  ['Career Success', 'Higher education and guided growth'],
];
